import React from 'react';
import { useIntl } from 'react-intl';

const ContactUs = () => {
  const intl = useIntl();
  const isEnglish = intl.locale === 'en';

  const renderContent = (id: string, fallback: string) => {
    return isEnglish ? fallback : intl.formatMessage({ id });
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-indigo-800 mb-6">
        {renderContent('contact.title', 'Contact Us')}
      </h1>
      <p className="text-lg mb-4">
        {renderContent('contact.description', 'We\'d love to hear from you! If you have any questions, suggestions, or feedback about Pokedle, please don\'t hesitate to reach out.')}
      </p>
      <div className="bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-2xl font-semibold text-indigo-700 mb-4">
          {renderContent('contact.getInTouch', 'Get in Touch')}
        </h2>
        <ul className="space-y-2">
          <li><strong>{renderContent('contact.email', 'Email')}:</strong> support@pokedle.com</li>
          <li><strong>{renderContent('contact.twitter', 'Twitter')}:</strong> @PokedleGame</li>
          <li><strong>{renderContent('contact.discord', 'Discord')}:</strong> {renderContent('contact.discordDescription', 'Join our Pokedle community server')}</li>
        </ul>
      </div>
    </div>
  );
};

export default ContactUs;